import {getAuthenticatedThemisClient, IndustryView} from '@modifi/onboarding-api-clients'
import {EntityFactory} from '@modifi/redux'

import {AppThunkAction} from '../../types/redux'

const apiClient = getAuthenticatedThemisClient()

const {actions, reducer, selectors} = EntityFactory({
  actionNamePrefix: 'data/industries',
  reducerPath: ['data', 'industries'],
  fetchRequest: () =>
    apiClient?.StaticData?.fetchIndustries().then(res => res.data()?.industryList || []),
})

export default reducer

export const selectIndustryList = (state: Record<string, any>): IndustryView[] =>
  (selectors.selectEntity(state) || []) as unknown as IndustryView[]

export const selectIndustriesAreLoading = selectors.selectIsLoading

const aFetchIndustries = (): AppThunkAction => actions.fetch()

export const aEnsureFetchIndustries =
  (): AppThunkAction<void> =>
  (dispatch, getState): void => {
    const industries = selectIndustryList(getState())
    if (!industries?.length) {
      dispatch(aFetchIndustries())
    }
  }
